import { TIcon } from "@/app/types/types";

const MenuIcon = ({ color }: TIcon) => {
    return (
        <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.5 12.125V10.625H17.5V12.125H0.5ZM0.5 7.25V5.75H17.5V7.25H0.5ZM0.5 2.375V0.874999H17.5V2.375H0.5Z" fill={color} />
        </svg>
    );
}

export default MenuIcon;